export default __webpack_public_path__ + "static/assets/3d95a42623afebe90a05863ceea86eff.svg";